import { Alert, PageUtils } from '@/core/utils'
import ApiErrorValidations from '@/core/exceptions/ApiErrorValidations'
import ConfigRequisicaoUtils from '@/core/utils/ConfigRequisicaoUtils'
import { chavesConfigRequisicao, mensagens, mutationTypes } from '@/core/constants'
import router from '@/views/routers'
import store from '@/core/store'

const alert = new Alert(store)
const pageUtils = new PageUtils(router)

class ExceptionHandler {
	execute(error) {
		if (error instanceof ApiErrorValidations) {
			this.tratarValidationError(error)
		} else {
			this.tratarError(error)
		}
		store.commit(mutationTypes.COMUM.SET_DESABILITAR_SALVAMENTO_AUTOMATICO)
	}

	tratarValidationError(error) {
		if (error.multipleErrors()) {
			this.handleMultipleErrors(error.response.data.messages)
		} else if (error.disconnected()) {
			this.handleDisconnected()
		} else if (error.unauthorized()) {
			this.handleUnauthorized()
		} else if (error.internalError()) {
			this.handleInternalError(error)
		} else if (error.notFound()) {
			this.handleNotFound(error)
		} else if (error.badRequest()) {
			this.tratarError(error)
		} else if (error.forbidden()) {
			this.handleForbidden(error)
		} else {
			this.handleUnknown()
		}
	}

	tratarError(error) {
		alert.showError(error.message)
	}

	handleMultipleErrors(errors) {
		const errorMsg = errors
			.map((err, index) => {
				if (index < errors.length - 1) {
					return err.message + ' '
				}

				return err.message
			})
			.reduce((total, prox) => {
				return total + prox
			})
		alert.showError(errorMsg)
	}

	handleDisconnected() {
		alert.showError(mensagens.DISCONNECTED)
		pageUtils.goToHome()
	}

	handleUnauthorized() {
		alert.showError(mensagens.LOST_SESSION)
		pageUtils.reload()
	}

	handleForbidden(error) {
		this.handleInternalError(error)

		if (ConfigRequisicaoUtils.isAtiva(error, chavesConfigRequisicao.REDIRECIONAMENTO_DESABILITADO)) {
			return
		}

		pageUtils.goToForbidden()
	}

	handleNotFound(error) {
		this.handleInternalError(error)
	}

	handleInternalError(error) {
		this.handleErrorData(error.response.data)
	}

	handleErrorData(data) {
		if (this.isString(data)) {
			this.handleErrorDataString(data)
		} else if (this.isObject(data)) {
			this.handleErrorDataObject(data)
		} else {
			this.handleUnknown()
		}
	}

	handleErrorDataString(data) {
		alert.showError(data)
	}

	handleErrorDataObject(data) {
		if (this.isBlob(data)) {
			this.handleErrorDataBlob(data)
		} else if (this.isArrayBuffer(data)) {
			this.handleErrorArrayBuffer(data)
		} else {
			this.handleErrorData(data.message)
		}
	}

	handleErrorDataBlob(data) {
		if (this.isBlobTypeJson(data)) {
			data.text().then((text) => {
				const dataAsJson = JSON.parse(text)
				this.handleErrorData(dataAsJson)
			})
		} else {
			this.handleUnknown()
		}
	}

	handleErrorArrayBuffer(data) {
		try {
			const decoder = new TextDecoder('utf-8')
			const errorText = decoder.decode(data)
			const errorJson = JSON.parse(errorText)
			this.handleErrorData(errorJson.message)
		} catch {
			this.handleUnknown()
		}
	}

	isObject(data) {
		return !!data && typeof data === 'object'
	}

	isString(data) {
		return !!data && typeof data === 'string'
	}

	isBlob(data) {
		return data instanceof Blob
	}

	isArrayBuffer(data) {
		return data instanceof ArrayBuffer
	}

	isBlobTypeJson(blob) {
		return blob.type === 'application/json'
	}

	handleUnknown() {
		alert.showError(mensagens.UNKNOWN)
	}
}

export default new ExceptionHandler()
